import { __decorate } from "tslib";
import { mapGetters } from "vuex";
import { Component, Prop, Vue } from "vue-property-decorator";
let OptionsPopover = class OptionsPopover extends Vue {
    target;
    show;
    save;
    stateClass;
    condition;
    findInStore;
    mounted() {
        window.addEventListener('keypress', this.handleKeyPress);
    }
    destroyed() {
        window.removeEventListener('keypress', this.handleKeyPress);
    }
    saveAction(option) {
        this.save(this.target, this.condition, option._id);
        this.close();
    }
    close() {
        this.$root.$emit('bv::hide::popover');
    }
    get options() {
        let condition = this.findInStore({ query: { condition: this.condition } }).data[0];
        if (!condition)
            return [];
        return condition.options;
    }
    handleKeyPress(e) {
        if (!this.show)
            return;
        if (!e.key.match(/^-?\d+$/))
            return;
        let index = parseInt(e.key) - 1;
        if (!this.options[index])
            return;
        this.save(this.target, this.condition, this.options[index]._id);
    }
};
__decorate([
    Prop({ type: Number, required: true })
], OptionsPopover.prototype, "target", void 0);
__decorate([
    Prop({ type: Boolean })
], OptionsPopover.prototype, "show", void 0);
__decorate([
    Prop({ type: Function, required: true })
], OptionsPopover.prototype, "save", void 0);
__decorate([
    Prop({ type: Function, required: true })
], OptionsPopover.prototype, "stateClass", void 0);
__decorate([
    Prop({ type: String, required: true })
], OptionsPopover.prototype, "condition", void 0);
OptionsPopover = __decorate([
    Component({
        computed: {
            ...mapGetters('configurator', { findInStore: 'find' }),
        }
    })
], OptionsPopover);
export default OptionsPopover;
